import type { MenuDividerProps as ChakraMenuDividerProps } from '@chakra-ui/react';
import { MenuDivider as ChakraMenuDivider } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';

export type MenuDividerProps = OmitChakraProps<ChakraMenuDividerProps>;

export const MenuDivider = (props: MenuDividerProps) => {
  return <ChakraMenuDivider {...props} />;
};
